import { AWSCShortbread } from '@amzn/shortbread';

export const shortbread = AWSCShortbread({
  domain: window?.location?.hostname,
  parent: document.body,
  registry: {
    hw: {
      category: 'essential',
    },
  },
});
